// extracted by mini-css-extract-plugin
export var avatarContainer = "_6p-0";
export var avatarTypingWave = "_6p-i";
export var gray = "_6p-f";
export var green = "_6p-c";
export var icon = "_6p-9";
export var image = "_6p-1";
export var lg = "_6p-6";
export var md = "_6p-5";
export var presenceDot = "_6p-b";
export var red = "_6p-d";
export var sm = "_6p-4";
export var status = "_6p-a";
export var typingDot = "_6p-h";
export var typingPill = "_6p-g";
export var xl = "_6p-7";
export var xs = "_6p-3";
export var xxl = "_6p-8";
export var xxs = "_6p-2";
export var yellow = "_6p-e";